var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search" }, [
    _c("div", { staticClass: "row no-gutters justify-content-end" }, [
      _c(
        "div",
        {
          staticClass: "search-input-wrap",
          attrs: { "data-v-step": "search" },
        },
        [
          _c("input", {
            directives: [
              {
                name: "debounce",
                rawName: "v-debounce:1s",
                value: _vm.submitSearch,
                expression: "submitSearch",
                arg: "1s",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Search for your slide" },
            domProps: { value: _vm.query },
          }),
          _vm._v(" "),
          _vm.query
            ? _c("div", { staticClass: "search-reset" }, [
                _c("img", {
                  staticClass: "search-reset-icon",
                  attrs: {
                    src: require("@/assets/images/icon-close.png"),
                    alt: "Reset search",
                  },
                  on: { click: _vm.resetSearch },
                }),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", {}, [
        _c(
          "button",
          {
            staticClass: "button button-secondary w-100 search-button",
            on: {
              click: function ($event) {
                return _vm.submitSearch(_vm.query)
              },
            },
          },
          [_c("span", [_vm._v("Search")])]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }